import styled from "styled-components";
import Home from "./Home/Home";
import NavBar from "./NavBar/NavBar";
import { Routes, Route, useLocation } from "react-router-dom";

import About from "./AboutAndContact/About";
import Contact from "./AboutAndContact/Contact";
import Projects from "./Projects/Projects";
import Airplane from "./Projects/ProjectInfo/projectpages/Airplane";
import Coffee from "./Projects/ProjectInfo/projectpages/Coffee";
import Trello from "./Projects/ProjectInfo/projectpages/Trello";
import Eclipse from "./Projects/ProjectInfo/projectpages/Eclipse";
import { AnimatePresence, motion } from "framer-motion";
import AnimatedPage from "./AnimatedPage";
import BehindChange from "./Projects/ProjectInfo/projectpages/BehindChange";
import Tetris from "./Projects/ProjectInfo/projectpages/Tetris";
import Violin from "./Projects/ProjectInfo/projectpages/Violin";
import Prevport from "./Projects/ProjectInfo/projectpages/Prevport";

const StyledApp = styled.div`
  max-width: 1500px;
  overflow-x: hidden;
  margin: auto;
`;
const StyledNavBar = styled(NavBar)``;
const StyledWorkspace = styled(motion.div)`
  max-width: 1200px;

  margin: 2rem auto;
  padding: 0 1em 3em 1em;
`;

function App() {
  const location = useLocation();
  return (
    <StyledApp>
      <StyledNavBar />
      <StyledWorkspace>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route
              path="/"
              element={
                <AnimatedPage>
                  <Home />
                </AnimatedPage>
              }
            />
            <Route
              path="about"
              element={
                <AnimatedPage>
                  <About />
                </AnimatedPage>
              }
            />
            <Route
              path="projects"
              element={
                <AnimatedPage>
                  <Projects />
                </AnimatedPage>
              }
            />
            <Route
              path="airplane"
              element={
                <AnimatedPage>
                  <Airplane />
                </AnimatedPage>
              }
            />
            <Route
              path="coffee"
              element={
                <AnimatedPage>
                  <Coffee />
                </AnimatedPage>
              }
            />
            <Route
              path="trello"
              element={
                <AnimatedPage>
                  <Trello />
                </AnimatedPage>
              }
            />

            <Route
              path="eclipse"
              element={
                <AnimatedPage>
                  <Eclipse />
                </AnimatedPage>
              }
            />

            <Route
              path="behindchange"
              element={
                <AnimatedPage>
                  <BehindChange />
                </AnimatedPage>
              }
            />

            <Route
              path="tetris"
              element={
                <AnimatedPage>
                  <Tetris />
                </AnimatedPage>
              }
            />
            <Route
              path="violin"
              element={
                <AnimatedPage>
                  <Violin />
                </AnimatedPage>
              }
            />

            <Route
              path="prevport"
              element={
                <AnimatedPage>
                  <Prevport />
                </AnimatedPage>
              }
            />

            <Route
              path="contact"
              element={
                <AnimatedPage>
                  <Contact />
                </AnimatedPage>
              }
            />
          </Routes>
        </AnimatePresence>
      </StyledWorkspace>
    </StyledApp>
  );
}

export default App;
